import { authClient, API } from '../index'

export const getGamificationAudioguidesAdmin = () => {
  return authClient().get(`${API}/gamification-audioguides/admin`)
}

export const getGamificationAudioguideById = (id) => {
  return authClient().get(`${API}/gamification-audioguides/${id}`)
}

export const postGamificationAudioguide = (data) => {
  return authClient().post(`${API}/gamification-audioguides`, data)
}

export const updateGamificationAudioguide = (id, data) => {
  return authClient().put(`${API}/gamification-audioguides/${id}`, data)
}

export const deleteGamificationAudioguide = (id) => {
  return authClient().delete(`${API}/gamification-audioguides/${id}`)
}
